import { KngButtonState, KngFooterState } from 'kinetic-angular';
import { IdLabelPair, Image } from '../../../../../services/shared/shared-interface';

export interface ConfirmRegistration {
    state: ConfirmRegistrationState;
}
export interface ConfirmRegistrationState {
    pageHeading: string;
    pageDescription: string;
    logo: Image;
    refreshPageButton: KngButtonState;
    footer: KngFooterState;
    pageLabels: ConfirmPageSections;
    loading: boolean;
}

export interface ConfirmPageSections {
    pendingApproval: ConfirmPageLabels;
    pendingBusinessAccountApproval: ConfirmPageLabels;
    submittedRegistrationForReview: ConfirmPageLabels;
}
export interface ConfirmPageLabels {
    logo: Image;
    mainText: string;
    subText: string;
    refreshButton: IdLabelPair;
}
